import "./footer.css"


const Footer=()=>{
return(<footer className='footer text-center flex jc-center ai-center'>
  <div>
    © 2022 DEVSTORE
  </div>
</footer>)
}


export default Footer;